import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-calendar-filters',
  templateUrl: './calendar-filters.component.html',
  styleUrls: ['./calendar-filters.component.scss'],
})
export class CalendarFiltersComponent implements OnInit {
  @Input() currentPath: string;

  constructor() {}

  ngOnInit(): void {}
}
